export const ZKEX_SYMBOL_TO_BINANCE_API: Record<string, string> = {
  'WETH-USD': 'ETHUSDT',
  'WBTC-USD': 'BTCUSDT',
  'WMATIC-USD': 'MATICUSDT',
  'WAVAX-USD': 'AVAXUSDT',
  'JOE-USD': 'JOEUSDT',
  'QUICK-USD': 'QUICKUSDT',

  WBTC_USDC: 'BTCUSDT',
  BTC_USDC: 'BTCUSDT',
  WETH_USDC: 'ETHUSDT',
  WBTC_USDT: 'BTCUSDT',
  BTC_USDT: 'BTCUSDT',
  WETH_USDT: 'ETHUSDT',
  ETH_USDT: 'ETHUSDT',
  AVAX_USDT: 'AVAXUSDT',
  MATIC_USDT: 'MATICUSDT',
  OP_USDT: 'OPUSDT',
  ARB_USDT: 'ARBUSDT',
  BNB_USDT: 'BNBUSDT',
  ETH_BTC: 'ETHBTC',
  USDC_USDT: 'USDCUSDT',
  XETH: 'ETHUSDT',
  XBTC: 'BTCUSDT',
  XWETH: 'ETHUSDT',
  XWBTC: 'BTCUSDT',
}

export const MainSelectIntervalsValue = ['15m', '1H', '4H', '1D']
export type ResolutionType = '1m' | '5m' | '15m' | '30m' | '1H' | '4H' | '1D'
export const MobileMainSelectIntervalsValue = ['15m', '1H', '4H']
export const SelectIntervalsValue = [
  '1m',
  '5m',
  '15m',
  '30m',
  '1H',
  '4H',
  '1D',
  '1W',
  '1M',
]
export type ResolutionValueType =
  | '1'
  | '5'
  | '15'
  | '30'
  | '60'
  | '240'
  | '1D'
  | '1W'
  | '1M'
export const RESOLUTION_OPTIONS = {
  '1m': '1',
  '5m': '5',
  '15m': '15',
  '30m': '30',
  '1H': '60',
  '4H': '240',
  '1D': '1D',
  '1W': '1W',
  '1M': '1M',
  '1': '1m',
  '5': '5m',
  '15': '15m',
  '30': '30m',
  '60': '1H',
  '240': '4H',
}

export const BINANCE_RESOLUTION_OPTIONS: Record<string, string> = {
  '1': '_1m',
  '5': '_5m',
  '15': '_15m',
  '30': '_30m',
  '60': '_1h',
  '240': '_4h',
  '1D': '_1d',
  '1W': '_1w',
  '1M': '_1M',
}

export const SELECT_INTERVAL_MENU: Record<
  string,
  Array<{ label: string; value: string }>
> = {
  Minutes: [
    {
      label: '1 minute',
      value: '1m',
    },
    {
      label: '5 minute',
      value: '5m',
    },
    {
      label: '15 minute',
      value: '15m',
    },
    {
      label: '30 minute',
      value: '30m',
    },
  ],
  Hours: [
    {
      label: '1 hour',
      value: '1H',
    },
    {
      label: '4 hour',
      value: '4H',
    },
  ],
  Days: [
    {
      label: '1 day',
      value: '1D',
    },
  ],
  Weeks: [
    {
      label: '1 week',
      value: '1W',
    },
  ],
  Months: [
    {
      label: '1 month',
      value: '1M',
    },
  ],
}
